<template>
  <div>
    <div class="filter" style="margin-top:-30px;">
      <el-tabs type="border-card" class="card-tab">
        <el-tab-pane label="筛选">
          <el-form :model="param" :inline="true" label-width="200px" class="formInline" size="mini">
            <div class="slide-wrap" style="height: auto;">
              <el-form-item label="开始日期">
                <el-date-picker value-format="yyyy-MM-dd" v-model="param.startDate" type="date">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束日期">
                <el-date-picker value-format="yyyy-MM-dd" v-model="param.endDate" type="date">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="员工id">
                <el-input v-model="param.clerkId" placeholder="请输入员工id..." :maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="param.clerkName" placeholder="请输入姓名..." :maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="省">
                <el-input v-model="param.province" placeholder="请输入所在省..." :maxlength="15"></el-input>
              </el-form-item>
              <el-form-item label="市">
                <el-input v-model="param.city" placeholder="请输入所在市..." :maxlength="15"></el-input>
              </el-form-item>
              <el-form-item label="县">
                <el-input v-model="param.country" placeholder="请输入所在县..." :maxlength="15"></el-input>
              </el-form-item>
              <el-form-item label="门店名称">
                <el-input v-model="param.storeName" placeholder="请输入所在门店名称..." :maxlength="15"></el-input>
              </el-form-item>
              <el-form-item label="门店编号">
                <el-input v-model="param.storeCode" placeholder="请输入所在门店编号..." :maxlength="15"></el-input>
              </el-form-item>
              <el-form-item label="扫码消费者微信昵称">
                <el-input v-model="param.wechatName" placeholder="请输入扫码消费者微信昵称..." :maxlength="25"></el-input>
              </el-form-item>
              <el-form-item label="促销员回收样是否有效">
                <el-select v-model="param.isValid" filterable placeholder="请选择...">
                  <el-option :label="item.name" :value="item.id" v-for="(item,index) in chooseValid"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="无效样本原因">
                <el-input v-model="param.reasonStr" placeholder="请输入无效样本原因..." :maxlength="25"></el-input>
              </el-form-item>
              <el-form-item label="活动名称">
                <el-input v-model="param.activityName" placeholder="请输入活动名称..." :maxlength="25"></el-input>
              </el-form-item>
              <el-form-item label="供应商名称">
                <el-input v-model="param.supplierName" placeholder="请输入供应商名称..." :maxlength="25"></el-input>
              </el-form-item>
            </div>
            <hr style="margin-bottom: 9px;">
            <div class="slide-btns clearfix">
              <el-form-item>
                <el-button type="text" class="reset-btn" @click="resetParams">清空</el-button>
                <el-button class="search-btn" @click="searchData">筛选</el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="上传数据" v-loading="handling" element-loading-text="正在处理中">
          <div style="text-align: center;padding: 50px;">
            <el-upload
              action="/rest/questionnaire/import"
              :before-upload="handlePreview"
              :on-success='handleSuccess'
              :on-error='handleError'
              :show-file-list="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="tableBody">
        <el-table class="limitManagerTable table-expand" style="width: 100%;" size="small" border :data="tableData">
          <el-table-column width="50" type="index" label="#" align="center"></el-table-column>
          <el-table-column width="100" prop="createDate" label="日期" align="center" :formatter="dateFormat"></el-table-column>
          <el-table-column width="100" prop="clerkId" label="员工id" align="center"></el-table-column>
          <el-table-column width="100" prop="clerkName" label="姓名" align="center"></el-table-column>
          <el-table-column width="91" prop="province" label="所在省" align="center"></el-table-column>
          <el-table-column width="91" prop="city" label="所在市" align="center"></el-table-column>
          <el-table-column width="91" prop="country" label="所在县" align="center"></el-table-column>
          <el-table-column width="91" prop="storeName" label="门店名称" align="center"></el-table-column>
          <el-table-column width="91" prop="storeCode" label="门店编号" align="center"></el-table-column>
          <el-table-column width="140" prop="wechatName" label="扫码消费者微信昵称" align="center"></el-table-column>
          <el-table-column width="160" prop="isValid" label="促销员回收样是否有效" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.isValid == 1">有效</div>
              <div v-if="scope.row.isValid == 0">无效</div>
            </template>
          </el-table-column>
          <el-table-column width="300" prop="reasonStr" label="无效样本原因" align="center"></el-table-column>
          <el-table-column width="100" prop="activityName" label="活动名称" align="center"></el-table-column>
          <el-table-column width="100" prop="supplierName" label="供应商名称" align="center"></el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 50, 100]" :page-size="formData.pageSize"
                       layout="slot,sizes, total,  prev, pager, next, jumper" :total="formData.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: "questionnaire",
    data() {
      return {
        param: {
          clerkId: null, // 员工id
          clerkName: null, // 姓名
          province: null, // 所在省份
          city: null, // 所在城市
          country: null, // 所在区县
          storeName: null, // 门店名称
          storeCode: null, // 门店编号
          wechatName: null, // 扫码消费者微信昵称
          isValid: null, // 促销员回收样本有效/无效
          reasonStr: null, // 无效样本原因,
          startDate: null, // 开始日期
          endDate: null, // 结束日期
          activityName: null, // 活动名称
          supplierName: null // 供应商名称
        },
        formData: {
          pageNo: 1,
          pageSize: 10,
          total: null
        },
        tableData: [],
        chooseValid: [
          {name: '不限', id: null},
          {name: "有效", id: 1},
          {name: "无效", id: 0}
        ],
        handling: false
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      // 翻页
      handleSizeChange(value) {
        this.formData.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.formData.pageNo = value;
        this.getData();
      },
      getData() {
        this.$http({
          method: 'POST',
          url: '/rest/questionnaire/list',
          data: this.param,
          params: {
            pageNo: this.formData.pageNo,
            pageSize: this.formData.pageSize
          }
        }).then(res => {
          if (res.data && res.data.code == '0') {
            var data = res.data.data;
            this.formData.total = data.totalCount;
            this.tableData = data.results;
          }
        }).catch(err => {

        });
      },
      resetParams() {
        this.param.startDate = null;
        this.param.endDate = null;
        this.param.clerkId = null;
        this.param.clerkName = null;
        this.param.province = null;
        this.param.city = null;
        this.param.country = null;
        this.param.wechatName = null;
        this.param.isValid = null;
        this.param.reasonStr = null;
        this.param.activityName = null;
        this.param.supplierName = null;
      },
      searchData() {
        this.formData.pageNo = 1;
        this.getData();
      },
      //时间格式化
      dateFormat:function(row, column) {
        var date = row[column.property];
        if (date == undefined) {
          return "";
        }
        return moment(date).format("YYYY-MM-DD");
      },
      handleSuccess(response, file, fileList) {
        this.handling = false;
        if (response.message == '导入成功') {
          this.getData();
        }
        this.$alert(response.message, '提示', {
          dangerouslyUseHTMLString: true,
          callback(){
            this.uploadDialog = false;
          }
        })
      },
      handlePreview() {
        return this.$confirm("上传新数据会清空原有数据，您确定上传吗？", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(() => {
          this.handling = true;
        });
      },
      handleError(err, response, file) {
        this.handling = false;
        let msg = "文件上传失败";
        if (!response || !response.message) {
          msg = "请求超时，请稍后再试";
        } else {
          msg = response.message;
          msg = msg.split("。").join("\n");
        }
        this.$alert(msg, '提示', {
          dangerouslyUseHTMLString: true,
          callback: action => {
            this.uploadDialog = false;
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/personnelCenter/questionnaire.vue